import React, { useState, useEffect } from 'react';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import SignInScreen from './components/SignInScreen';
import HomePage from './HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import StripeConnectCallback from './pages/StripeConnectCallback';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';

const fetchUnreadMessages = async (accessToken) => {
  const response = await fetch(
    'https://gmail.googleapis.com/gmail/v1/users/me/messages?labelIds=UNREAD&maxResults=10',
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  const data = await response.json();
  return data.messages || [];
};

const fetchMessageDetails = async (messageId, accessToken) => {
  const response = await fetch(
    `https://gmail.googleapis.com/gmail/v1/users/me/messages/${messageId}?format=metadata&metadataHeaders=Subject&metadataHeaders=From`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return await response.json();
};

function AppContent() {
  const [accessToken, setAccessToken] = useState(null);
  const [emails, setEmails] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [isNewLogin, setIsNewLogin] = useState(false);

  useEffect(() => {
    const savedToken = sessionStorage.getItem('accessToken');
    const savedUserInfo = sessionStorage.getItem('userInfo');
    if (savedToken) {
      setAccessToken(savedToken);
    }
    if (savedUserInfo) {
      setUserInfo(JSON.parse(savedUserInfo));
    }
  }, []);

  const login = useGoogleLogin({
    scope: 'https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/drive.file',
    prompt: 'consent',
    ux_mode: 'popup',
    onSuccess: async (tokenResponse) => {
      console.log("✅ scopes:", tokenResponse.scope);
      sessionStorage.setItem('accessToken', tokenResponse.access_token);
      setAccessToken(tokenResponse.access_token);

      // Fetch user info
      try {
        const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });
        const userData = await userInfoResponse.json();
        sessionStorage.setItem('userInfo', JSON.stringify(userData));
        setUserInfo(userData);

        // Mark this as a fresh login
        setIsNewLogin(true);
      } catch (error) {
        console.error("Failed to fetch user info:", error);
      }
    },
    onError: () => console.log("❌ Login failed"),
  });

  useEffect(() => {
    const loadEmails = async () => {
      if (!accessToken) return;
      const ids = await fetchUnreadMessages(accessToken);
      const fullEmails = await Promise.all(
        ids.map((msg) => fetchMessageDetails(msg.id, accessToken))
      );
      setEmails(fullEmails);
    };

    loadEmails();
  }, [accessToken]);

  return (
    <Routes>
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/stripe-connect/callback" element={<StripeConnectCallback />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/" element={
        !accessToken ? (
          <SignInScreen onSignIn={login} />
        ) : (
          <HomePage emails={emails} setEmails={setEmails} accessToken={accessToken} userInfo={userInfo} isNewLogin={isNewLogin} />
        )
      } />
    </Routes>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId="57391590231-goqgf0cekhq85meik3edvrvsos48m8aq.apps.googleusercontent.com">
      <Router>
        <AppContent />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;